import { CoreSwitch } from '@components'
import InfoIcon from '@images/icons/info-circle-black.svg?react'
import { tr } from 'mmfintech-commons'
import type { ReactNode } from 'react'
import ReactTooltip from 'react-tooltip'

import './exchangeFeeFromTkbToggle.scss'

/** Shared explanation line — "Using Kingdom Coin for fees %25 discount" — used
 *  both as the toggle's inline description and inside the dashboard popover so
 *  the wording stays in one place. */
export const TkbDiscountHint = () => (
  <>
    {tr('FRONTEND.DASHBOARD.TKB_DISCOUNT.HINT', 'Using Kingdom Coin for fees')}{' '}
    <span className='accent'>{tr('FRONTEND.DASHBOARD.TKB_DISCOUNT.HINT_ACCENT', '%25 discount')}</span>
  </>
)

type ExchangeFeeFromTkbTogglePopover = {
  /** Unique id tying the info anchor to its ReactTooltip instance. */
  id: string
  /** Rich content rendered inside the hover popover. */
  content: ReactNode
}

type ExchangeFeeFromTkbToggleProps = {
  isActive: boolean
  disabled?: boolean
  onToggle: (next: boolean) => void
  /** When provided, replaces the inline description with an on-hover popover. */
  popover?: ExchangeFeeFromTkbTogglePopover
}

export const ExchangeFeeFromTkbToggle = ({ isActive, disabled, onToggle, popover }: ExchangeFeeFromTkbToggleProps) => {
  const handleSwitch = () => {
    if (disabled) return
    onToggle(!isActive)
  }

  return (
    <div className='exchange-fee-from-tkb-toggle'>
      <div className='exchange-fee-from-tkb-toggle-content'>
        <div className='exchange-fee-from-tkb-toggle-badge'>
          <span className='exchange-fee-from-tkb-toggle-percent'>
            {tr('FRONTEND.EXCHANGE.PREVIEW.TKB_DISCOUNT_PERCENT', '%25 DISCOUNT')}
          </span>
          <span className='exchange-fee-from-tkb-toggle-suffix'>
            {tr('FRONTEND.EXCHANGE.PREVIEW.TKB_DISCOUNT_SUFFIX', 'ON FEES')}
          </span>
          {popover && (
            <span className='exchange-fee-from-tkb-toggle-info' data-tip data-for={popover.id}>
              <InfoIcon />
            </span>
          )}
        </div>
        {!popover && (
          <div className='exchange-fee-from-tkb-toggle-description'>
            <TkbDiscountHint />
          </div>
        )}
      </div>
      <CoreSwitch isActive={isActive} handleSwitch={handleSwitch} />
      {popover && (
        <ReactTooltip
          id={popover.id}
          place='bottom'
          effect='solid'
          type='light'
          clickable
          arrowColor='transparent'
          className='exchange-fee-from-tkb-toggle-popover'
          getContent={() => popover.content}
        />
      )}
    </div>
  )
}
